<template>
    <b-overlay :show="submitting || updating || generalDeleting" rounded="sm">
    <div class="health-view">
        <div class="bg-white p-3 mt-3 activity-type-create col-12">
            <div class="d-flex title-bar-block mb-2">
                <div class="icon-block me-4">
                    <button id="close-label-btn" v-b-tooltip.hover :title="$backLabel()" @click="cancel()">
                        <i class="fa fa-chevron-left text-white" aria-hidden="true"></i>
                    </button>
                </div>
                <div class="text">
                    <span class="me-2">{{ title }}</span>
                </div>
            </div>
                <b-form class="form-sample" @submit.stop.prevent="CreateOrUpdate">
                    <b-row>
                        <input type="hidden" v-model="model.customer_id">
                        <b-col cols="12">
                            <label class="mb-3"><strong>{{ $nameLabel() }}<span class="red">*</span> </strong></label>
                            <b-form-input type="text" id="input-name" v-custom-validation="$textRequired()" v-model="model.name"
                                required :placeholder="$translate('enter_name')" trim></b-form-input>
                        </b-col>
                        <!-- <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('attached_to') }}<span class="red">*</span> </strong></label>
                              <b-form-select
                                id="input-document_type"
                                v-model="model.attached_to"
                                :options="document_types"
                                required
                              ></b-form-select> 
                            </b-col> -->
                        
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{ $translate('description') }}</strong>
                            </label>
                            <b-form-textarea id="input-description" v-model="model.description"
                                :placeholder="$translate('enter_description')" rows="3"></b-form-textarea>
                        </b-col>
                        <b-col cols="12" class="mt-3">
                            <label class="mb-3"><strong>{{$translate('attachment')  }} </strong></label>
                          <view-attachments v-model="model.attachment"  @upload-btn-clicked="uploadClicked" />
                        </b-col>
                     
                         
                        <b-col cols="12" class="mt-3 d-flex gap-2 justify-content-center">
                            <b-button id="submit-btn" variant="info"  v-if="hasPermissionUpdate"   type="submit" class="btn-fw"
                                :disabled="submitting ? true : false">{{ submitLabel }}
                            </b-button>
                            <!-- <b-button variant="info" v-if="hasPermissionUpdate" type="submit" class="btn-fw"
                            :disabled="submitting ? true : false">{{ submitLabel }}
                        </b-button> -->
                            <!-- <b-button v-if="hasPermissionDelete && !isNew" @click="deletehealth()" class="float-right"
                                variant="delete-button" size="fw">
                                {{ $deleteLabel() }}
                            </b-button> -->
                            <b-button id="delete-btn" v-if="!isNew && hasPermissionDelete " @click="delete_document_type()" class="float-right"
                            variant="delete-button" size="fw">
                            {{ $deleteLabel() }}
                        </b-button>
                            <b-button id="cancel-btn" variant="info" :disabled="submitting" class="btn-fw" @click="cancel()">
                                {{ $cancelLabel() }}
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
        </div>
    </div>
    </b-overlay>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ViewAttachments from "./ViewAttachments.vue";
import customer_document from '../../api/customer_document';

export default {
    name: 'CustomerDocument',
    mixins: [popupMixins, permissionsMixins, utilityMixins],
    components:{
        ViewAttachments
    },
    data() {
        return {
            model: {
                id: 0,
                name: '',
                description:''
            },

            updating: false,

            submitting: false,
            isView : false,
            customer_id : 0,
        }
    },
    
    created() {
    // this.loadDocumentTypes();
    },
    computed: {
        componentName() { return this.$translate('customer_document') },
        submitLabel() {
            if (this.submitting && this.model.id) {
                return this.$translate('updating')
            } else if (this.submitting) {
                return this.$translate('creating')
            } else if (this.model.id) {
                return this.$updateLabel()
            } else {
                return this.$createLabel()
            }
        },
        title() {
            return this.isNew ? this.$translate('create_master_document') : this.$translate('master_document')
        },
        customer_document() {
            const customer_document = { ...this.$store.state.customer_document.document_type }
          
          
            return customer_document
        },
        // document_types(){
          
        //     return this.$store.state.master_document.document_types.map(x => ({
        //         value: x.id,
        //         text: x.name,
        //     }))
        // },
        document_types(){
          
          return [
        
                  {
                      value: 'customer',
                      text: 'Customer',
                  
                  },
                  {
                      value: 'activity',
                      text: 'Activity',
                  
                  }
              ];
        },
      
        user_permissions() {
            return this.$store.getters.user_permissions
        },
        isNew() {
            if (this.model.id == 0 || this.model.id == null) {
                return true
            } else {
                return false
            }
        },
        assetAttachments() {
            return this.$store.state.masterdocAttachmentsStore.attachments
         },
    },
    watch: {
        customer_document: function (val) {
            this.model = val
        },
    },
    methods: {
        cancel() {
            // this.$store.commit("master_document/clearAssetsAttachments",[]);
            // this.$store.commit("masterdocAttachmentsStore/clearAssetAttachments",[]);
            // this.$router.push('/ams/master-document')
            this.$router.go(-1);
        },
        
        uploadClicked() {
            this.$store.dispatch('js_report/fetchCredentials')
        },

        CreateOrUpdate() {
            this.submitting = true;
            // const { assetAttachments: attachments } = this;
            const payload = {
          ...this.model,
        //   attachments
        };
            this.$validator.validate().then(valid => {
                if (valid) {

                    // console.log('attachments',attachments);
                    this.$store
                        .dispatch(
                            this.model.id !== 0 ? 'customer_document/update' : 'customer_document/create',
                            payload
                        )
                        .then(() => {
                            if (this.model.id !== 0) {
                                this.$router.push({
                                name: 'viewCustomer',
                                params: { id: this.model.customer_id }  // Pass the customer ID
                            });
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('updated'),
                                        'success',
                                        `${this.componentName} ${this.$translate('update_alert')}`
                                    )
                                })

                            } else {
                                this.$router.push({
                                name: 'viewCustomer',
                                params: { id: this.model.customer_id }  // Pass the customer ID
                                });
                                this.$nextTick(() => {
                                    this.genericToast(
                                        this.componentName,
                                        this.$translate('created'),
                                        'success',
                                        `${this.componentName} ${this.$translate('create_alert')}`
                                    )
                                })
                            }
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            )
                            console.log(error)
                        })
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },

        async delete_document_type() {
            const type =  this.componentName;
            const title = `${this.$translate('delete')} ${type}?`
            const message = `${this.$translate('delete_note')} ${this.model.name ? this.model.name :  this.componentName}?`

            // Show confirmation message
            this.confirmMessage(title, message).then(result => {
                console.log('result', result);
                if (result) {
                    // User confirmed, proceed with deletion
                    this.submitting = true;

                    this.$store
                        .dispatch('customer_document/delete', this.model.id)
                        .then(() => {
                            this.$router.push({
                                name: 'viewCustomer',
                                params: { id: this.model.customer_id }  // Pass the customer ID
                            });

                            this.$nextTick(() => {
                                this.genericToast(
                                    this.componentName,
                                    this.$translate('deleted'),
                                    'success',
                                    `${this.componentName} ${this.$translate('delete_alert')}`
                                );
                            });
                        })
                        .catch(error => {
                            this.doToast(
                                this.$translate('error'),
                                error.message,
                                'danger'
                            );
                            console.error(error);
                        })
                        .finally(() => {
                            this.submitting = false;
                        });
                }
            });
        },
        // async loadDocumentTypes() {
        //      await this.$store.dispatch('master_document/fetchDocumentTypes');
        // }
    },
    async mounted() {
        if (this.$route.params.id !== 0) {
          await   this.$store.dispatch('customer_document/fetchById', this.$route.params.id);
            // await this.$store.dispatch("master_document/fetchAttachments", this.$route.params.id);
        }
        this.model.customer_id = this.$store.state.customers.item.id;
       
       
    },
    async confirmMessage(title, message) {
            const value = await this.$bvModal.msgBoxConfirm(message, {
                title,
                buttonSize: 'sm',
                headerClass: "p-0",
                footerClass: "d-flex justify-content-center border-0",
                contentClass: "custom-model-wrap",
                titleClass: "py-1",
                okVariant: 'info',
                okTitle: this.$translate('yes'),
                cancelTitle: this.$translate('no'),
                cancelVariant: 'info',
                hideHeaderClose: false,
                centered: true,
            })
            return value
        },

}
</script>
<style></style>
